var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import React, { useState } from 'react';
import { ShareEntityModal } from "./ShareEntityModal";






export const ShareButton = ({ sharedIds, storeKey }) => {
  const [sharing, setSharing] = useState(false);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { className: "btn btn-success share-btn", type: "button", onClick: () => setSharing(true) }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "user-plus" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Share")
    )
    ),
    sharing ? /*#__PURE__*/
    _jsx(ShareEntityModal, {

      isOpen: true,
      onClose: () => setSharing(false),
      sharedIds: sharedIds,
      storeKey: storeKey }, sharedIds.join('-')
    ) :
    null
    ));

};